import React, { useState, useEffect, useRef } from "react";

const patterns = [
  [1, 4],
  [0, 1, 2],
  [0, 3, 4, 5],
  [0, 2, 4, 6, 8],
  [0, 2, 6, 8],
  [1, 3, 4, 5, 7],
  [0, 1, 2, 3, 4, 5],
  [0, 2, 3, 4, 5, 6],
  [0, 1, 2, 3, 4, 5, 6],
  [0, 1, 2, 3, 4, 5, 6, 7, 8]
];

export default function SubitizingGame() {
  const [currentPattern, setCurrentPattern] = useState([]);
  const [input, setInput] = useState("");
  const [message, setMessage] = useState("");
  const [color, setColor] = useState("");
  const timeoutRef = useRef(null);

  const generatePattern = () => {
    const index = Math.floor(Math.random() * patterns.length);
    setCurrentPattern(patterns[index]);
    setMessage("");
    setColor("");
    setInput("");
  };

  const checkAnswer = () => {
    const inputNumber = parseInt(input, 10);
    if (inputNumber === currentPattern.length) {
      setMessage("✅ Correct!");
      setColor("green");
    } else {
      setMessage("❌ Try Again!");
      setColor("red");
    }

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      generatePattern();
    }, 1500);
  };

  useEffect(() => {
    generatePattern();
    return () => clearTimeout(timeoutRef.current);
  }, []);

  return (
    <div style={styles.body}>
      <h1>Subitizing Game</h1>

      <div style={styles.dots}>
        {Array.from({ length: 9 }).map((_, index) => (
          <div
            key={index}
            style={currentPattern.includes(index) ? styles.dot : { width: 30, height: 30 }}
          />
        ))}
      </div>

      <input
        type="number"
        placeholder="How many dots?"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        style={styles.input}
      />
      <button onClick={checkAnswer} style={styles.button}>
        Check
      </button>

      <div style={{ ...styles.message, color }}>{message}</div>
    </div>
  );
}

const styles = {
  body: {
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
    padding: 20,
  },
  dots: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 40px)",
    gridTemplateRows: "repeat(3, 40px)",
    gap: "5px",
    justifyContent: "center",
    marginBottom: "20px",
  },
  dot: {
    width: "30px",
    height: "30px",
    background: "black",
    borderRadius: "50%",
  },
  input: {
    padding: "10px",
    fontSize: "16px",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    marginLeft: "10px",
    cursor: "pointer",
  },
  message: {
    fontWeight: "bold",
    marginTop: "15px",
    minHeight: "1em",
  },
};
